import React, { useEffect, useState } from "react";
import { Search } from "semantic-ui-react";

import CardProduct from "../../components/Card/CardProduct";
import HttpService from "../../HttpService";
import CompareImage from "./compare.png";
import Carousel from "../../components/Carousel/Carousel2";
import _ from "lodash";

const CompareProduct = ({ location }) => {
  const [productList, setProductList] = useState([]);
  const [banners, setBanner] = useState([]);
  const [specShow, setSpecShow] = useState({
    build: "",
    processor: "",
    display: "",
    frequency: "",
    memory: "",
    camera: "",
    connectivity: "",
    features: "",
    battery: "",
  });
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedProductLoading, setSelectedProductLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [error, setError] = useState(null);
  const [value, setValue] = useState("");
  const [productListLoading, setProductListLoading] = useState(false);

  useEffect(() => {
    const fetchProducts = async () => {
      setError(false);

      try {
        setProductListLoading(true);
        if (location && location.state && location.state.products) {
          let products = null;

          products = location.state.products;
          setSelectedProduct(products);
        }
        const banner = await HttpService.get("/banners");

        setBanner(banner.data.banners[0] && banner.data.banners[0]);

        const productList = await HttpService.get("/products");
        setProductOptions(
          productList.data.products.map((product) => ({
            company_name: product.company_name,
            title: product.name,
            // description: "description",
            image: product.image,
            price: `Price : ${product.price}`,
            productDetails: product.productDetails,
            _id: product._id,
            key: product._id,
          }))
        );
      } catch (error) {
        setError(true);
      }

      setProductListLoading(false);
    };

    fetchProducts();
  }, [location]);

  const handleSearchChange = (e, { value }) => {
    setTimeout(() => {
      if (value.length < 1) {
        setValue(value);
        setProductList([]);
      }
      const re = new RegExp(_.escapeRegExp(value), "i");

      const isMatch = (result) => re.test(result.title);
      const results = _.filter(productOptions, isMatch);
      if (results.length > 0) {
        setProductList(results);
      } else {
        const isMatch = (result) => re.test(result.company_name);
        const results = _.filter(productOptions, isMatch);
        setProductList(results);
      }
    }, 300);
  };

  const handleResultSelect = async (e, data) => {
    let products = [];
    const product = await HttpService.get(`/product/${data.result._id}`);
    products = [...selectedProduct];
    products[data.index] = product.data;
    setSelectedProduct(products);
  };

  const getRows = (spec, specType) => {
    let rows = [];
    for (let i = 0; i <= 3; i++) {
      const row = (
        <>
          <td className="spec_table_border" key={i}>
            {selectedProduct &&
            selectedProduct[i] &&
            selectedProduct[i].productDetails[spec] &&
            selectedProduct[i].productDetails[spec][specType]
              ? selectedProduct[i].productDetails[spec][specType]
              : ""}
          </td>
        </>
      );
      rows.push(row);
    }
    return rows;
  };
  const closeCard = (index) => {
    let products = [];

    products = [...selectedProduct];
    products.splice(index, 1);

    setSelectedProduct(_.compact(products));
  };

  const closeSpecList = (spec) => {
    let status = "none";
    if (specShow[spec] === "none") {
      status = "";
    }
    setSpecShow((prevState) => ({
      ...prevState,
      [spec]: status,
    }));
  };

  return (
    <React.Fragment>
      <section>
        <Carousel
          image={banners && banners.image}
          heading={banners && banners.heading}
        />
      </section>
      <section
        className="product-details"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <div className="container">
          <div className="row compare-folding-section">
            <div className="col-12 text-center">
              <h2 className="compare-folding-title">Compare your Product</h2>
            </div>
          </div>
          <div
            className="row compare-products"
            style={{ borderRadius: "20px" }}
          >
            <div className="col-12">
              <table className="p0 table table-responsive">
                <tbody>
                  <tr>
                    <td>
                      <div className="choose-market text-center">
                        <div className="compare-product-add">
                          <i
                            className="fa fa-hand-o-right"
                            aria-hidden="true"
                          ></i>
                          <h6 className="compare-product-tile">
                            Compare product
                          </h6>
                          <p>
                            <u>{`${selectedProduct.length} products added`}</u>
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      {selectedProduct[0] && selectedProduct[0] ? (
                        <CardProduct
                          image={selectedProduct[0] && selectedProduct[0].image}
                          price={selectedProduct[0] && selectedProduct[0].price}
                          title={selectedProduct[0] && selectedProduct[0].name}
                          index={0}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={productListLoading}
                            index={0}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={productList}
                          />
                        </div>
                      )}
                    </td>
                    <td>
                      {selectedProduct[1] && selectedProduct[1] ? (
                        <CardProduct
                          image={selectedProduct[1] && selectedProduct[1].image}
                          price={selectedProduct[1] && selectedProduct[1].price}
                          title={selectedProduct[1] && selectedProduct[1].name}
                          index={1}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={productListLoading}
                            index={1}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Search"
                            results={productList}
                          />
                        </div>
                      )}
                    </td>
                    <td>
                      {selectedProduct[2] && selectedProduct[2] ? (
                        <CardProduct
                          image={selectedProduct[2] && selectedProduct[2].image}
                          price={selectedProduct[2] && selectedProduct[2].price}
                          title={selectedProduct[2] && selectedProduct[2].name}
                          index={2}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={productListLoading}
                            index={2}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={productList}
                          />
                        </div>
                      )}
                    </td>
                    <td>
                      {selectedProduct[3] && selectedProduct[3] ? (
                        <CardProduct
                          image={selectedProduct[3] && selectedProduct[3].image}
                          price={selectedProduct[3] && selectedProduct[3].price}
                          title={selectedProduct[3] && selectedProduct[3].name}
                          index={3}
                          removeCard={closeCard}
                        />
                      ) : (
                        <div style={{ paddingTop: 50 }}>
                          <Search
                            loading={productListLoading}
                            index={3}
                            onResultSelect={handleResultSelect}
                            size="small"
                            onSearchChange={handleSearchChange}
                            placeholder="Add to Compare"
                            results={productList}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                  {selectedProduct.length > 0 ? (
                    <>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("build")}
                          >
                            <i className="collapse"></i>
                            <span>Build</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.build,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  OS
                                </td>
                                {getRows("build", "os")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  UI
                                </td>
                                {getRows("build", "ui")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Dimensions
                                </td>
                                {getRows("build", "dimensions")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Weight
                                </td>
                                {getRows("build", "weight")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Sim
                                </td>
                                {getRows("build", "sim")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Colors
                                </td>
                                {getRows("build", "colors")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("processor")}
                          >
                            <i className="collapse"></i>
                            <span>Processor</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.processor,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Cpu
                                </td>
                                {getRows("processor", "cpu")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Chipset
                                </td>
                                {getRows("processor", "chipset")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  GPU
                                </td>
                                {getRows("processor", "gpu")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("display")}
                          >
                            <i className="collapse"></i>
                            <span>Display</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.display,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Technology
                                </td>
                                {getRows("display", "technology")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Size
                                </td>
                                {getRows("display", "size")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Resolution
                                </td>
                                {getRows("display", "resolution")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Protection
                                </td>
                                {getRows("display", "protection")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Extra Features
                                </td>
                                {getRows("display", "extra_features")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("frequency")}
                          >
                            <i className="collapse"></i>
                            <span>Frequency</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.frequency,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  2g Band
                                </td>
                                {getRows("frequency", "g2_band")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  3g Band
                                </td>
                                {getRows("frequency", "g3_band")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  4g Band
                                </td>
                                {getRows("frequency", "g4_band")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  5g Band
                                </td>
                                {getRows("frequency", "g5_band")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("memory")}
                          >
                            <i className="collapse"></i>
                            <span>Memory</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.memory,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Built In
                                </td>
                                {getRows("memory", "built_in")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Card
                                </td>
                                {getRows("memory", "card")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("camera")}
                          >
                            <i className="collapse"></i>
                            <span>Camera</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.camera,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Main
                                </td>
                                {getRows("camera", "main")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Features
                                </td>
                                {getRows("camera", "features")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Front
                                </td>
                                {getRows("camera", "front")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("connectivity")}
                          >
                            <i className="collapse"></i>
                            <span>Connectivity</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.connectivity,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Wlan
                                </td>
                                {getRows("connectivity", "wlan")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Gps
                                </td>
                                {getRows("connectivity", "gps")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Bluetooth
                                </td>
                                {getRows("connectivity", "bluetooth")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Usb
                                </td>
                                {getRows("connectivity", "usb")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Nfc
                                </td>
                                {getRows("connectivity", "nfc")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Radio
                                </td>
                                {getRows("connectivity", "radio_1")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Data
                                </td>
                                {getRows("connectivity", "data")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("features")}
                          >
                            <i className="collapse"></i>
                            <span>Features</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.features,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Sensors
                                </td>
                                {getRows("features", "sensors")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Audio
                                </td>
                                {getRows("features", "audio")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Browser
                                </td>
                                {getRows("features", "browser")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Messaging
                                </td>
                                {getRows("features", "messaging")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Games
                                </td>
                                {getRows("features", "games")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Torch
                                </td>
                                {getRows("features", "torch")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Extra
                                </td>
                                {getRows("features", "extra")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5">
                          <div
                            className="compare_hdn"
                            onClick={() => closeSpecList("battery")}
                          >
                            <i className="collapse"></i>
                            <span>Battery</span>
                          </div>
                        </td>
                      </tr>
                      <tr
                        className="animate"
                        style={{
                          display: specShow.battery,
                        }}
                      >
                        <td colSpan="5">
                          <table className=" table table-responsive">
                            <tbody>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Capacity
                                </td>
                                {getRows("battery", "capacity")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Talktime
                                </td>
                                {getRows("battery", "talktime")}
                              </tr>
                              <tr>
                                <td className="spec_table_border specTitle">
                                  Musicplay
                                </td>
                                {getRows("battery", "musicplay")}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="5">
                        <div className="row compare-folding-section">
                          <div className="col-12 text-center">
                            <img
                              src={CompareImage}
                              style={{ height: 200, width: 200 }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default CompareProduct;
